import { apiSlice } from './apiSlice';
import { ApiResponse } from '@/types';

export interface JoinRequest {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  mobile: string;
  description: string | null;
  createdAt: string;
}

export interface PaginatedResponse<T> {
  count: number;
  skip: number;
  take: number;
  data: T[];
}

export interface GetJoinRequestsArgs {
  search?: string;
  skip?: number;
  take?: number;
}

import { handleOptimisticDelete } from './optimisticUpdates';

export const communityApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getJoinRequests: builder.query<PaginatedResponse<JoinRequest>, GetJoinRequestsArgs | void>({
      query: (args) => {
        let url = '/community/requests';
        if (args) {
          const params = new URLSearchParams();
          if (args.search) params.append('search', args.search);
          if (args.skip !== undefined) params.append('skip', args.skip.toString());
          if (args.take !== undefined) params.append('take', args.take.toString());
          const queryString = params.toString();
          if (queryString) {
            url += `?${queryString}`;
          }
        }
        return url;
      },
      transformResponse: (response: ApiResponse<PaginatedResponse<JoinRequest>>) => {
        return response.data;
      },
      providesTags: ['Community'],
    }),
    deleteJoinRequest: builder.mutation<void, { id: number; reason: string }>({
      query: ({ id, reason }) => ({
        url: `/community/requests/${id}`,
        method: 'DELETE',
        body: { reason },
      }),
      invalidatesTags: ['Community'],
    }),
  }),
});

export const {
  useGetJoinRequestsQuery,
  useLazyGetJoinRequestsQuery,
  useDeleteJoinRequestMutation,
} = communityApi;
